export default __webpack_public_path__ + "static/media/radiant-bright-green-yellow.8a497025.jpg";